
export enum ErrorMessage{
    None = 0,
    GeneralError = 1,
    InvalidValue = 2
}

export namespace ErrorMessage{
    export function toString(errorMessage:ErrorMessage):string{
        switch(errorMessage){
            case ErrorMessage.None:
                return '';
            case ErrorMessage.GeneralError:
                return 'An error occurred while issuing a capital call, please try again later or ';
            case ErrorMessage.InvalidValue:
                return 'Investment data is invalid, please check again or ';
            default:
                return '';
        }
    }
}

export default ErrorMessage;